var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auditStatistics)?_c('number-card',{attrs:{"warning":"","bold":"","amount":_vm.inProgressAudits,"title":_vm.$it('dashboard.card.audits-in-progress.title', 'Audits In Progress')}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }